interface MolocoProps {
  id: string;
  event_type: 'HOME' | 'SEARCH' | 'ADD_TO_WISHLIST' | 'PAGE_VIEW';
  timestamp: number;
  channel_type: 'APP' | 'SITE'; // APP, SITE
  user_id?: string;
  page_id: string;
  session_id: string;
}

interface MolocoSearchProps extends MolocoProps {
  search_query: string;
}

interface MolocoAddToWishProps extends MolocoProps {
  items: MolocoAddtoWishItem[];
}

interface MolocoAddtoWishItem {
  id: string;
  price: {
    currency: 'KRW';
    amount: number;
  };
  quantity: number;
}

interface MolocoLogEvent {
  event: 'moloco_log_event';
  molocoData: MolocoProps;
}

interface SearchPageView extends MolocoLogEvent {
  molocoData: MolocoSearchProps;
}

interface AddToWishEvent extends MolocoLogEvent {
  molocoData: MolocoAddToWishProps;
}

export const ADD_TO_WISHLIST: AddToWishEvent = {
  event: 'moloco_log_event',
  molocoData: {
    id: '',
    event_type: 'ADD_TO_WISHLIST',
    timestamp: 0,
    channel_type: 'SITE', // APP, SITE
    user_id: '',
    page_id: '',
    session_id: '',
    items: [
      {
        id: '',
        price: {
          currency: 'KRW',
          amount: 0,
        },
        quantity: 1,
      },
    ],
  },
};

export const HOME: MolocoLogEvent = {
  event: 'moloco_log_event',
  molocoData: {
    id: '',
    event_type: 'HOME',
    timestamp: 0,
    channel_type: 'SITE', // APP, SITE
    user_id: '',
    page_id: '',
    session_id: '',
  },
};

export const MOLOCO_PAGE_VIEW: MolocoLogEvent = {
  event: 'moloco_log_event',
  molocoData: {
    id: '',
    event_type: 'PAGE_VIEW',
    timestamp: 0,
    channel_type: 'SITE', // APP, SITE
    user_id: '',
    page_id: '',
    session_id: '',
  },
};

export const SEARCH: SearchPageView = {
  event: 'moloco_log_event',
  molocoData: {
    id: '',
    event_type: 'SEARCH',
    timestamp: 0,
    channel_type: 'SITE', // APP, SITE
    user_id: '',
    page_id: '',
    search_query: '',
    session_id: '',
  },
};

export const DECISION_CLICK_TRACKER = {
  event: 'moloco_decision_click_tracker',
  molocoData: '',
};

export const DECISION_IMP_TRACKER: { event: string; molocoData: string[] } = {
  event: 'moloco_decision_imp_tracker',
  molocoData: [],
};
